import React, { useState } from 'react';

import { Button, ListItemIcon } from '@mui/material';

type Props = React.HTMLProps<HTMLDivElement> & {
	icon?: string;
	iconHover?: string;
	link?: string;
}

export default function SubtleButton(props:Props) {
	const [hover, setHover] = useState(false);

	const getButton = () => <Button color="secondary" className="MuiButton-subtle">
		{props.icon && <ListItemIcon><i className="material-icons">
			{hover && props.iconHover ? props.iconHover : props.icon}
		</i></ListItemIcon>}
		{props.children}
	</Button>

	const { icon, iconHover, link, children, ...otherProps }  = props;

	return <div 
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			{ ...otherProps }
		>
		{props.link ? <a href={props.link} target="_blank">{getButton()}</a> : getButton()}
	</div>
}